import apiClient from "../authentication/utils/core/axios";

/**
 * Fetch news sentiment data for a given stock symbol.
 * @param {string} symbol - Ticker symbol
 * @returns {Promise<Object>} - News sentiment response data
 */
const fetchNewsSentiment = async (symbol) => {
  const response = await apiClient.get(`/stocks_news_sentiment/${symbol}`);
  if (response.status !== 200) throw new Error('Failed to fetch sentiment data');
  return response.data;
};


/**
 * Fetch news sentiment data for multiple tickers (batch).
 * @param {string[]} tickers - Array of ticker symbols
 * @param {number} limit - Number of articles to fetch per ticker (optional)
 * @returns {Promise<Object[]>} - Flat array of news articles, each with a ticker field
 */
const fetchBatchNewsSentiment = async (tickers, limit = 20) => {
  const response = await apiClient.post(`/stocks_news_sentiment/batch`, {tickers, limit});
  if (response.status !== 200) throw new Error('Failed to fetch batch sentiment data');
  return response.data;
};

// ✅ Single export with both functions
export default {
  fetchNewsSentiment,
  fetchBatchNewsSentiment,
};